import { createContext, useContext } from "react";

export const ProposalFormsContext = createContext();

export const useProposalFormsContext = () =>  useContext(ProposalFormsContext);

